<template>
    <Modal @close="onClose">
        <template #content>
            <ModalStandard :uiTitle="titleLbl" :uiIsGlobal="false" @close="onClose" class="br-m">
                <template #body>
                    <div v-if="loading" class="dw-10 dh-10">
                        <Loader class="dw-10 dh-10"
                            title="mead.labels.loading"
                            :uiAbsolute="false" />
                    </div>
                    <p v-else>{{ descLbl | athT }}</p>
                </template>
                <template v-if="!loading" #footer>
                    <AthButton class="el--s-m el--t-primary"
                        @click="onConfirm($event)"
                        :qa="'modal-confirm-button'"
                        :lbl="confirmLbl" />
                </template>
            </ModalStandard>
        </template>
    </Modal>
</template>

<script>
import ModalStandard from '../modal-styles/Standard.vue';
import Loader from '../../atoms/Loader.vue';
import AthButton from '../../atoms/Button.vue';
import Modal from './Modal.vue';

export default {
    name: 'mead-standalone-confirm-modal',
    props: {
        /**
         * Title text (i18n key) displayed in the modal's header.
         */
        titleLbl: {type: String, default: ''},
        /**
         * Description text (i18n key) displayed in the modal body while not loading.
         */
        descLbl: {type: String, default: ''},
        /**
         * Label text (i18n key) for the confirm button.
         */
        confirmLbl: {type: String, default: 'mead.labels.confirm'},
        /**
         * Whether the modal is in a loading state; shows a loader in place of the description
         * and hides the footer's confirm button while true.
         */
        loading: {type: Boolean, default: false}
    },
    components: {Modal, ModalStandard, Loader, AthButton},
    methods: {
        onConfirm: function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('confirm');
        },
        onClose: function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('close');
        },
    },
};
</script>
